import { useEffect } from 'react';

// Utils
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useAtom, useSetAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Atoms
import {
    deadlineDateTimeAtom,
    deadlineTimezoneAtom,
    optionsAtom,
    toggleDeadlineAtom
} from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';
// Components
import { DateSection } from '@/components/pages/giveaway-picker/OptionsWrapper/components/Deadline/DateSection';
import { TimeAndTimezoneSection } from '@/components/pages/giveaway-picker/OptionsWrapper/components/Deadline/TimeAndTimezoneSection';
import { ToggleOption } from '@/components/pages/giveaway-picker/OptionsWrapper/components/ToggleOption';

dayjs.extend(timezone);
dayjs.extend(utc);

export const Deadline = () => {
    const { t } = useTranslation('giveaway_picker');
    const [deadlineTimezone, setDeadlineTimezone] = useAtom(deadlineTimezoneAtom);
    const [deadlineDateTime, setDeadlineDateTime] = useAtom(deadlineDateTimeAtom);
    const setOptions = useSetAtom(optionsAtom);
    const [toggle, setToggle] = useAtom(toggleDeadlineAtom);

    useEffect(() => {
        if (toggle && deadlineDateTime && deadlineTimezone) {
            setOptions((prev) => ({
                ...prev,
                deadline: dayjs.tz(deadlineDateTime, deadlineTimezone).utc().format()
            }));
        }
    }, [deadlineDateTime, deadlineTimezone, toggle]);

    const handleToggle = () => {
        if (toggle) {
            setOptions((prev) => ({
                ...prev,
                deadline: null
            }));
            setToggle(false);
            return;
        }
        const tzGuess = dayjs.tz.guess();
        setDeadlineTimezone(tzGuess);
        setDeadlineDateTime(dayjs().tz(tzGuess).format());
        setToggle(true);
    };

    return (
        <ToggleOption
            title={t('options.deadline')}
            subtitle={t('options.select_date')}
            toggle={toggle}
            onToggle={handleToggle}>
            <div className="flex flex-col gap-3 sm:flex-row" data-testid="deadline-section">
                <DateSection />
                <TimeAndTimezoneSection />
            </div>
        </ToggleOption>
    );
};
